const Reflux = require('@muzzylane/reflux');
const ServerRequest = require('./request');
const ErrorConsts = require('../constants/error');
const ForgeError = require('../util/error');

const RegisterActions = Reflux.createActions({
    registerEmail: { children: ['completed', 'failed'] },
    register: { children: ['completed', 'failed'] },
    userInfo: { children: ['completed', 'failed'] },
});

RegisterActions.registerEmail.listen(function(actionID, params) {
    let valid = true;
    let errorUIRefs = [];
    let errorMsg;

    if (!params.email1) {
        valid = false;
        errorMsg = ErrorConsts.MISSING_PARAMS;
        errorUIRefs.push("email1");
    }

    if (!params.email2) {
        valid = false;
        errorMsg = ErrorConsts.MISSING_PARAMS;
        errorUIRefs.push("email2");
    }

    if (valid && (params.email1 !== params.email2)) {
        valid = false;
        errorMsg = ErrorConsts.EMAIL_MATCH;
        errorUIRefs.push("email1", "email2");
    }

    if (!valid) {
        this.failed(actionID, new ForgeError({ message: errorMsg, uiRefs: errorUIRefs }));
        return;
    }

    ServerRequest.makeRequest('/authoring/register/email', 'POST', JSON.stringify({
            email: params.email1
        }))
        .then(res => this.completed(actionID, res))
        .catch(err => this.failed(actionID, err));
});

RegisterActions.register.listen(function(actionID, params) {
    let valid = true;
    let errorUIRefs = [];
    let errorMsg;

    if (!params.firstName) {
        valid = false;
        errorMsg = ErrorConsts.MISSING_PARAMS;
        errorUIRefs.push("firstName");
    }

    if (!params.lastName) {
        valid = false;
        errorMsg = ErrorConsts.MISSING_PARAMS;
        errorUIRefs.push("lastName");
    }

    if (!params.password) {
        valid = false;
        errorMsg = ErrorConsts.MISSING_PARAMS;
        errorUIRefs.push("password");
    }

    if (!params.passwordConfirm) {
        valid = false;
        errorMsg = ErrorConsts.MISSING_PARAMS;
        errorUIRefs.push("passwordConfirm");
    }

    if (!params.displayName) {
        valid = false;
        errorMsg = ErrorConsts.MISSING_PARAMS;
        errorUIRefs.push("displayName");
    }

    if (valid && params.password !== params.passwordConfirm) {
        valid = false;
        errorMsg = ErrorConsts.PASSWORD_MATCH;
        errorUIRefs.push("password", "passwordConfirm");
    }

    if (valid && (params.password.length < 8)) {
        valid = false;
        errorMsg = ErrorConsts.PASSWORD_LENGTH;
        errorUIRefs.push("password", "passwordConfirm");
    }

    if (!valid) {
        this.failed(actionID, new ForgeError({ message: errorMsg, uiRefs: errorUIRefs }));
        return;
    }

    ServerRequest.makeRequest('/authoring/register', 'POST', JSON.stringify({
            firstName: params.firstName,
            lastName: params.lastName,
            password: params.password,
            displayName: params.displayName,
            affiliation: params.affiliation || "",
            buildQuestion: params.buildQuestion || "",
            // receiveUpdates: params.receiveUpdates || false, // TODO?
            // receiveNewsletter: params.receiveNewsletter || false, // TODO?
            secret: params.key
        }))
        .then(res => this.completed(actionID, res))
        .catch(err => this.failed(actionID, err));
});

RegisterActions.userInfo.listen(function(actionId, params) {
    let valid = true;
    let errorUIRefs = [];
    let errorMsg;

    if (!params.secret) {
        valid = false;
        errorMsg = ErrorConsts.MISSING_SECRET;
    }

    if (!valid){
        this.failed(actionId, new ForgeError({message: errorMsg, uiRefs: errorUIRefs}));
        return;
    }

    ServerRequest.makeRequest('/authoring/register/info/' + params.secret, 'GET')
        .then(res => this.completed(actionId, res))
        .catch(err => this.failed(actionId, err));
});

module.exports = RegisterActions;